"use client";

import { motion } from "motion/react";
import { useState } from "react";

import { readForm, submitAccessRequest } from "@/lib/access-request";
import {
  Field,
  FormError,
  Honeypot,
  PreferEmail,
  SubmitButton,
  SuccessState,
  inputClass,
  selectClass,
} from "@/components/FormFields";

export function TalentManagementForm() {
  const [submitted, setSubmitted] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setPending(true);
    setError(null);
    try {
      await submitAccessRequest("talent_management", readForm(e.currentTarget));
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong. Please try again.");
    } finally {
      setPending(false);
    }
  }

  if (submitted) {
    return (
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}>
        <SuccessState title="Thank you! We'll reach out soon." />
      </motion.div>
    );
  }

  return (
    <>
      <h2 className="text-3xl font-display font-semibold text-gray-900 mb-8">
        Agency Details
      </h2>

      <form onSubmit={handleSubmit} className="relative space-y-5">
        <Honeypot />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Contact name" htmlFor="tm-name" required>
            <input id="tm-name" name="fullName" required type="text" autoComplete="name" placeholder="Full name" className={inputClass} />
          </Field>
          <Field label="Email" htmlFor="tm-email" required>
            <input id="tm-email" name="email" required type="email" autoComplete="email" placeholder="you@agency.com" className={inputClass} />
          </Field>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field label="Agency / Company name" htmlFor="tm-company" required>
            <input id="tm-company" name="company" required type="text" autoComplete="organization" placeholder="Enter agency name" className={inputClass} />
          </Field>
          <Field label="Website" htmlFor="tm-website">
            <input id="tm-website" name="website" type="text" inputMode="url" autoComplete="url" placeholder="agency.com" className={inputClass} />
          </Field>
        </div>

        <Field label="Talent under management" htmlFor="tm-count" required>
          <select id="tm-count" name="talentCount" required className={selectClass}>
            <option value="">Select an option</option>
            <option value="1-50">1-50</option>
            <option value="51-200">51-200</option>
            <option value=">200">&gt;200</option>
          </select>
        </Field>

        <FormError message={error} />

        <SubmitButton pending={pending}>Submit</SubmitButton>

        <PreferEmail />
      </form>
    </>
  );
}
